import React, { useState } from "react";
import {
  Box,
  Stack,
} from "@mui/material";

import CancelIcon from '@mui/icons-material/Cancel';
import { useLoadAuthUser, useCompleteSignIn } from "../../hooks/authhooks";
import CustomTextField from "../../components/Mobile/CustomTextField";
import { AuthSchema } from "../../data/types"
import { ReactComponent as SentEmailIcon } from "../../icons/SentEmailIcon.svg";
import { ReactComponent as GoogleIcon } from "../../icons/GoogleIcon.svg";
import { ReactComponent as FacebookIcon } from "../../icons/FacebookIcon.svg";

type LoginProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Login: React.FC<LoginProps> = ({ setIsOpen }) => {

  const { signInWithGoogle, signInWithFacebook } =  useCompleteSignIn()
  const { registerUser } = useLoadAuthUser()
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [fullName, setFullName] = useState<string>('')
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [isSignUp, setIsSignUp] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  return (
    <div
      // onMouseLeave={() => setIsOpen(false)}
      className="py-1 text-center transition cursor-default mx-2"
    >
      <button
        type="button"
        aria-label="Cancel"
        onClick={() => setIsOpen(false)}
        className="ml-auto w-full flex cursor-pointer bg-transparent border-none p-0"
      >
        <CancelIcon className="text-[#A1A1A1] hover:text-[#777] my-1 h-[18px] w-[18px] ml-auto" />
      </button>
      {
        (submitted) ? (
          <SubmittedLogin submitted={submitted} email={email} setEmail={setEmail} registerUser={registerUser} setSubmitted={setSubmitted} />
        ) : (
          <UnSubmittedLogin 
            submitted={submitted} 
            setIsOpen={setIsOpen}
            email={email} 
            setEmail={setEmail} 
            registerUser={registerUser} 
            setSubmitted={setSubmitted}
            password={password}
            setPassword={setPassword}
            fullName={fullName}
            setFullName={setFullName}
            isSignUp={isSignUp}
            setIsSignUp={setIsSignUp}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            error={error}
            setError={setError}
            signInWithGoogle={signInWithGoogle}
            signInWithFacebook={signInWithFacebook}
            // registerWithEmailPassword={registerWithEmailPassword}
            // signInWithEmailPassword={signInWithEmailPassword}
          />
        )
      }
  </div>
  );
};



type BaseLoginProps = {
  email: string
  submitted: boolean
  setEmail: React.Dispatch<React.SetStateAction<string>>
  registerUser: (user: AuthSchema) => boolean
  setSubmitted: React.Dispatch<React.SetStateAction<boolean>>
}

type UnSubmittedLoginProps = BaseLoginProps & {
  password: string
  setPassword: React.Dispatch<React.SetStateAction<string>>
  fullName: string
  setFullName: React.Dispatch<React.SetStateAction<string>>
  isSignUp: boolean
  setIsSignUp: React.Dispatch<React.SetStateAction<boolean>>
  showPassword: boolean
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>
  error: string
  setError: React.Dispatch<React.SetStateAction<string>>
  signInWithGoogle: () => Promise<any>
  signInWithFacebook: () => Promise<any>
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  // registerWithEmailPassword: (email: string, password: string) => Promise<any>
  // signInWithEmailPassword: (email: string, password: string) => Promise<any>
}

const UnSubmittedLogin: React.FC<UnSubmittedLoginProps> = ({
  email, 
  submitted, 
  setIsOpen,
  setEmail, 
  registerUser, 
  setSubmitted,
  password,
  // setPassword,
  fullName,
  setFullName,
  isSignUp,
  // setIsSignUp,
  // showPassword,
  // setShowPassword,
  error,
  setError,
  signInWithGoogle,
  signInWithFacebook,
  // registerWithEmailPassword,
  // signInWithEmailPassword
}) => {

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      await signInWithGoogle();
    } catch (error: any) {
      // setError(error.message || 'Google sign-in failed');
      setError('Google sign-in failed, please try again');
    }
    if (error){
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  };

  const handleFacebookSignIn = async () => {
    try {
      setError('');
      await signInWithFacebook();
    } catch (error: any) {
      // setError(error.message || 'Facebook sign-in failed');
      setError('Facebook sign-in failed, please try again');
    }

    if (error){
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  };

  // const handleEmailPasswordSubmit = async () => {
  //   try {
  //     setError('');
  //     if (isSignUp) {
  //       await registerWithEmailPassword(email, password);
  //     } else {
  //       await signInWithEmailPassword(email, password);
  //     }
  //   } catch (error: any) {
  //     setError(error.message || `${isSignUp ? 'Registration' : 'Sign-in'} failed`);
  //   }
  // };

  const openInNewTab = (url: string) => {
    window.open(url, "_blank");
  };

  const handleEmailLinkSubmit = () => {
    try {
      setError('');
      // set value of current page url to local storage
      // localStorage.setItem('currentPageUrl', window.location.href);
      // set value of path of current page url to local storage
      localStorage.setItem('lastPagePath', window.location.pathname);
      registerUser({email, last_page_path: window.location.pathname});
      setSubmitted(true);
    } catch (error: any) {
      // setError(error.message || 'Failed to send email link');
      setError('Failed to send email link, please try again');
    }
  };

  return (
    <>
      {/* <h1 className="text-xl text-primaryDark-200 font-bold my-1 font-raleway  text-left">
        {isSignUp ? 'Sign Up' : 'Sign In'}
      </h1> */}
      
      {error && (
        <p className="text-red-600 text-sm mb-2 text-center">{error}</p>
      )}

      <Stack className="w-full space-y-4 mt-4">
        {/* Social Sign-in Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleGoogleSignIn}
            className="w-full h-[48px] bg-white border border-gray-300 rounded-lg flex items-center justify-center space-x-3 hover:bg-gray-50 transition-colors"
          >
            <GoogleIcon className="w-5 h-5" />
            <span className="text-gray-700 font-medium">
              {isSignUp ? 'Sign Up' : 'Sign In'} with Google
            </span>
          </button>
          
          <button
            onClick={handleFacebookSignIn}
            className="w-full h-[48px] bg-white border border-gray-300 rounded-lg flex items-center justify-center space-x-3 hover:bg-gray-50 transition-colors"
          >
            <FacebookIcon className="w-5 h-5" />
            <span className="text-gray-700 font-medium">
              {isSignUp ? 'Sign Up' : 'Sign In'} with Facebook
            </span>
          </button>
        </div>

        {/* Divider */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">Or Continue with</span>
          </div>
        </div>

        {/* Email/Password Form */}
        <div className="space-y-4">
          {isSignUp && (
            <div className="flex flex-row justify-between w-full">
              <div>
                <label className="block text-md font-raleway font-medium text-[#808080] mb-1 text-left">
                  First Name
                </label>
                <input
                  type="text"
                  className="w-full border-[#E9E9E9] border-[1px] rounded-md h-[54px]"
                  placeholder="Enter your first name"
                  name="first_name"
                  value={fullName}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFullName(e.target.value)}
                />
                {/* <CustomTextField
                  size="small"
                  type="text"
                  variant="outlined"
                  className="w-full border-[#E9E9E9]"
                  placeholder="Enter your full name"
                  fullWidth
                  value={fullName}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFullName(e.target.value)}
                /> */}
              </div>
              <div>
                <label className="block text-md font-raleway font-medium text-[#808080] mb-1 text-left">
                  Last Name
                </label>
                <input
                  type="text"
                  className="w-full border-[#E9E9E9] border-[1px] rounded-md h-[54px]"
                  placeholder="Enter your last name"
                  name="last_name"
                  value={fullName}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFullName(e.target.value)}
                />
              </div>
            </div>
          )}

          <div>
            <label className="block text-sm font-raleway font-medium text-[#808080] mb-1 text-left">
              Sign {isSignUp ? 'Up' : 'In'} Link
            </label>
            <input
              type="email"
              data-testid="email-input"
              className="w-full border-[#E9E9E9] border-[1px] rounded-md h-[54px]"
              placeholder="Enter your email address"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            />
            {/* <CustomTextField
              size="small"
              type="email"
              variant="outlined"
              className="w-full border-[#E9E9E9] border-0"
              placeholder="forexample@gmail.com"
              fullWidth
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            /> */}
          </div>

          {/* <div>
            <label className="block text-md font-raleway font-medium text-[#808080] mb-1 text-left">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full border-[#E9E9E9] border-[1px] rounded-md h-[54px]"
                placeholder={isSignUp ? "Create your password" : "Enter your password"}
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
              />
              
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="border-0 bg-transparent absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div> */}

          {/* Password Requirements for Sign Up */}
          {isSignUp && (
            <div className="text-xs text-gray-600 space-y-1">
              <div className={`flex items-center ${password.length >= 8 ? 'text-green-600' : 'text-gray-400'}`}>
                <span className="mr-2">✓</span>
                At least 8 characters
              </div>
              <div className={`flex items-center ${/[A-Z]/.test(password) ? 'text-green-600' : 'text-gray-400'}`}>
                <span className="mr-2">✓</span>
                At least one uppercase letter (A-Z)
              </div>
              <div className={`flex items-center ${/[a-z]/.test(password) ? 'text-green-600' : 'text-gray-400'}`}>
                <span className="mr-2">✓</span>
                At least one lowercase letter (a-z)
              </div>
              <div className={`flex items-center ${/\d/.test(password) ? 'text-green-600' : 'text-gray-400'}`}>
                <span className="mr-2">✓</span>
                At least one number (0-9)
              </div>
              <div className={`flex items-center ${/[!@#$%^&*(),.?":{}|<>]/.test(password) ? 'text-green-600' : 'text-gray-400'}`}>
                <span className="mr-2">✓</span>
                At least one special character (like !, @, #, $, etc.)
              </div>
            </div>
          )}

          {/* Forgot Password Link for Sign In */}
          {/* {!isSignUp && (
            <div className="text-right">
              <div className="text-primaryDark-300 hover:text-primaryDark-300 font-medium cursor-pointer inline-block text-sm">
                Forgot Password
              </div>
            </div>
          )} */}

          {/* Submit Button */}
          <button
            onClick={handleEmailLinkSubmit}
            disabled={!email}
            className={`w-full h-[54px] bg-primaryDark-200 hover:bg-[#012a35] border-0 text-white rounded-lg font-bold text-[18px] transition-colors ${
              !email
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : ''
            }`}
          >
            {/* Sign {isSignUp ? 'Up' : 'In'} with Email Link */}
            Send Email Link
          </button>
        </div>

        {/* Email Link Option */}
        {/* <div className="text-center">
          <p className="text-[14px] text-gray-600 mb-2">
            Or sign {isSignUp ? 'up' : 'in'} with email link
          </p>
          <button
            onClick={handleEmailLinkSubmit}
            disabled={!email}
            className={`w-full h-[48px] border-0 rounded-lg font-medium transition-colors ${
              !email
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'text-gray-100 hover:text-gray-200 bg-primaryDark-300'
            }`}
          >
            Send Email Link
          </button>
        </div> */}

        {/* Toggle between Sign Up and Sign In */}
        {/* <div className="text-center font-open-sans">
          <p className="text-sm text-gray-600">
            {isSignUp ? 'I already have an account' : "I don't have an account"}{' '}
            <div
              onClick={() => {
                setIsSignUp(!isSignUp);
                setError('');
                setPassword('');
                setFullName('');
              }}
              className="text-primaryDark-400 hover:text-primaryDark-300 font-bold cursor-pointer inline-block"
            >
              {isSignUp ? 'Sign in.' : 'Sign Up.'}
            </div>
          </p>
        </div> */}

        {/* Terms and Conditions */}
        <div className="text-center text-xs text-gray-500">
          By signing {isSignUp ? 'up' : 'in'} you agree to our{' '}
          <div onClick={()=>openInNewTab("/terms")} className="text-primaryDark-300 hover:text-primaryDark-300 font-medium cursor-pointer inline-block">
            Terms & Conditions.
          </div>
        </div>
      </Stack>
    </>
  );
};



const SubmittedLogin: React.FC<BaseLoginProps> = ({email, registerUser, submitted, setSubmitted, setEmail}) => {
  const [resent, setResent] = useState(false);
  return (
    <>
    <div className="rounded-full p-3 border-[#E6E6E6] border-[1px] w-[64px] h-[64px] mx-auto">
      <SentEmailIcon className="m-auto h-[32px] w-[32px]" />
    </div>
    
    <h1 className="text-md text-primaryDark-200 font-bold my-2 font-raleway text-[24px] text-center">You're Almost There!</h1>
      <p className="text-[16px] text-left my-2 text-[#333333] font-open-sans">
        Check your email for the sign-up link. If you don't see it in your inbox, be sure to check your spam or junk folder.
      </p>
      <Box className="h-15 w-full mb-2">
        <CustomTextField
          disabled
          size="small"
          type="email"
          variant="outlined"
          className="w-full border-[#E9E9E9]"
          placeholder="Enter your email address"
          fullWidth
          value={email}
          onChange={() => {}}
        />
      </Box>
      <button 
        onClick={() => {
          registerUser({email, last_page_path: window.location.pathname});
          setResent(true);
        }}
        disabled={resent}
        className={`!mt-0 w-full h-[54px] ${resent ? 'bg-[#E6E6E6]' : 'bg-[#013847] hover:bg-[#E6E6E6]'} text-white font-bold border-0 text-[18px]`}
      >
        {resent ? 'Resent Link' : 'Resend Link'}
      </button>
    </>
  )
}

export default Login;
